<template>
  <main
    class="py-14 md:py-28 lg:py-24 xl:max-w-screen-xl mx-4 lg:mx-20 xl:mx-auto space-y-4 lg:space-y-6"
  >
    <h4
      class="leading-6 text-primar-400 text-base text-center font-semibold uppercase"
    >
      
    </h4>
    <h3
      class="text-xl lg:text-3xl text-gray-900 font-bold text-center"
    >
     
    </h3>
    <div
      class="flex flex-col text-xl lg:text-3xl text-gray-900 font-bold text-left"
    >
      <span class="text-primar-400">{{$t("partnership.textOne")}}</span>
      <span class="mt-4 text-lg font-light">{{$t("partnership.textTwo")}}</span>
      <span class="mt-4 text-lg">{{$t("partnership.textThree")}}</span>
    </div>
    <div
      class="flex flex-col md:grid md:grid-cols-40/60 md:gap-10"
    >
      <div
        class="relative overflow-hidden rounded-xl md:aspect-h-1 md:aspect-w-2"
      >
        <img
          src="/images/hands_square.webp"
          class="w-full h-full rounded-xl object-center object-cover"
          alt="Hands square"
        />
      </div>
      <div
        class="mt-10 lg:mt-0 space-y-10"
      >
        <form
          role="form"
          class="space-y-4"
          @submit="onSubmit"
        >
          <div>
            <input
              type="text"
              class="w-full py-2 px-4 bg-transparent shadow border rounded-md font-light text-base text-gray-900 placeholder-gray-500 transition duration-200 focus:outline-none focus:bg-white focus:border-gray-300"
              placeholder="Full name"
              required
              v-model='contact.name'
            />
          </div>
          <div>
            <input
              type="email"
              class="w-full py-2 px-4 bg-transparent shadow border rounded-md font-light text-base text-gray-900 placeholder-gray-500 transition duration-200 focus:outline-none focus:bg-white focus:border-gray-300"
              placeholder="Email"
              required
              v-model='contact.email'
            />
          </div>
          <div>
            <input
              type="tel"
              class="w-full py-2 px-4 bg-transparent shadow border rounded-md font-light text-base text-gray-900 placeholder-gray-500 transition duration-200 focus:outline-none focus:bg-white focus:border-gray-300"
              placeholder="Phone"
              required
              v-model='contact.phone'
            />
          </div>
          <div>
            <input
              type="text"
              class="w-full py-2 px-4 bg-transparent shadow border rounded-md font-light text-base text-gray-900 placeholder-gray-500 transition duration-200 focus:outline-none focus:bg-white focus:border-gray-300"
              placeholder="Subject"
              required
              v-model='contact.subject'
            />
          </div>
          <input type="hidden" v-model="contact.parser" />
          <div>
            <textarea
              type="email"
              class="w-full h-24 lg:h-40 py-2 px-4 bg-transparent shadow border rounded-md font-light text-base text-gray-900 placeholder-gray-500 transition duration-200 focus:outline-none focus:bg-white focus:border-gray-300"
              placeholder="Message"
              required
              v-model='contact.message'
            />
          </div>
          <button
            v-if="!isSending"
            type="submit"
            class="flex-shrink-0 bg-blue-800 text-white font-medium text-sm xl:text-base py-2 px-4 rounded-md shadow hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-800 focus:ring-offset-2 focus:ring-offset-blue-200"
          >
            Submit
          </button>
          <button 
            v-else
            class="flex-shrink-0 bg-gray-100 text-gray-500 font-medium text-sm xl:text-base py-2 px-4 rounded-md shadow"
          >
            Sending...
          </button>
          <div v-if="sentSuccess" class="flex items-center bg-green-500 text-white text-sm font-bold px-4 py-3" role="alert">
            <svg class="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"/></svg>
            <p>Successfully sent.</p>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>
<script>
const axios = require('axios');
export default {
  components: {},
  created() {
    
  },
  data() {
		return {
      contact: {
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        parser: '',
      },
      sentSuccess: false,
      isSending: false
    };
	},
  methods: {
		clearForm() {
      this.sentSuccess = false;
			for (let field in this.contact) {
				this.contact[field] = ''
			}
		},
		onSubmit(evt) {
			evt.preventDefault();

			this.isSending = true;

			setTimeout(() => {
				// Build for data
				let form = new FormData();
				for (let field in this.contact) {
					form.append(field, this.contact[field]);
				}

				// Send form to server	
				axios.post('/api/public/partnerForm', form).then((response) => {
					this.clearForm();
					this.isSending = false;
          this.sentSuccess = true;
				}).catch((e) => {
					console.log(e)
				});

			}, 1000);
		}
	}
};
</script>